"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subtitle = exports.StepContainer = exports.StepBar = exports.Container = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = require("../Text");

var Container = _styledComponents.default.div.withConfig({
  componentId: "sc-btfqnm-0"
})([""]);

exports.Container = Container;

var StepContainer = _styledComponents.default.div.withConfig({
  componentId: "sc-btfqnm-1"
})(["width:100%;padding:1px;border-radius:", ";margin-bottom:", "px;", ""], _tokens.borderRadius.pill, _tokens.spacing.vertical.xxxxs, function (_ref) {
  var theme = _ref.theme;
  return "\n    border: ".concat(_tokens.borderWidth.xs, "px solid ").concat(_tokens.colors[theme.colors.neutral600.color + theme.colors.neutral600.scale], ";\n  ");
});

exports.StepContainer = StepContainer;

var StepBar = _styledComponents.default.div.withConfig({
  componentId: "sc-btfqnm-2"
})(["border-radius:", "px;", ""], _tokens.borderRadius.md, function (_ref2) {
  var theme = _ref2.theme,
      percentage = _ref2.percentage,
      size = _ref2.size;
  return "\n    width: ".concat(percentage, "%;\n    background-color: ").concat(_tokens.colors[theme.colors.success.color + theme.colors.success.scale], ";\n    height: ").concat(size.height, "px;\n  ");
});

exports.StepBar = StepBar;
var Subtitle = (0, _styledComponents.default)(_Text.Text).attrs({
  size: 'subtitle01'
}).withConfig({
  componentId: "sc-btfqnm-3"
})([""]);
exports.Subtitle = Subtitle;